import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { ListagemProdutoComponent } from '../../views/relatorio/listagem-produto/listagem-produto.component';
import { RazaoClasseGerencial } from '../interfaces/razao-classe-gerencial';

@Injectable({
  providedIn: 'root'
})
export class RazaoClasseGerencialService {

  readonly url = `${environment.apiURL}/relatorio/razao_classe_gerencial`;

  constructor(private http: HttpClient) { }

  saveOrUpdate(relatorio: RazaoClasseGerencial): Observable<RazaoClasseGerencial> {
    return this.http.put<RazaoClasseGerencial>(`${this.url}`, relatorio);
  }

  getItem(id: number ): Observable<RazaoClasseGerencial> {
    return this.http.get<RazaoClasseGerencial>(`${this.url}/${id}`);
  }

  getItemPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<RazaoClasseGerencial>> {
    return this.http.get<PageResult<RazaoClasseGerencial>>(`${this.url}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getItemPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<RazaoClasseGerencial>> {
    return this.http.get<PageResult<RazaoClasseGerencial>>(`${this.url}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }

  printForm(controle: number , formId: number, onlyPrint = false): Observable<any> {
    return this.http.get(`${this.url}/print/${controle}/${formId}/${onlyPrint}`, {responseType: 'arraybuffer'});
  }
}
